/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_Reply_CheckInputs */



/**
* | output |
* | --- |
* | "Reply Checked" |
*
* @param {Transcript_Export_Field_Reply_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_reply_check = /** @type {((inputs?: Transcript_Export_Field_Reply_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_Reply_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reply Checked")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reply Checked")
	return /** @type {LocalizedString} */ ("Reply Checked")
});